import { z } from "zod"

export const organizationBasicInfoSchema = z.object({
  aboutText: z
    .string()
    .max(5000, "About text must be 5000 characters or less")
    .nullable(),
  industry: z
    .string()
    .max(255, "Industry must be 255 characters or less")
    .nullable(),
  foundedDate: z.string().datetime().nullable(),
})

export type OrganizationBasicInfoFormData = z.infer<
  typeof organizationBasicInfoSchema
>
